import {
	INSTALLS_DATA,
	INSTALLS_LOADED,
	INSTALLS_ERROR,
	INSTALLS_FILTERS_DATA,
	INSTALLS_FILTERS_LOADED,
	INSTALLS_FILTERS_ERROR
} from "../reducers/installsReducer";

export const getInstallsData = (url, params) => dispatch => {

	dispatch({ type: INSTALLS_LOADED, payload: false });

	const filtersToURLparams = (filters) => {
		let URLparams = "";
		for (let i = 0, keys = Object.keys(filters); i < keys.length; ++i) {
			if (Array.isArray(filters[keys[i]]))
				for (const arg of filters[keys[i]]) URLparams += `&${keys[i]}=${arg}`;
			else URLparams += `&${keys[i]}=${filters[keys[i]]}`;
		}
		return URLparams;
	}

	fetch(`${url}?${filtersToURLparams(params)}`)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: INSTALLS_DATA, payload: data._data });
				dispatch({ type: INSTALLS_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: INSTALLS_ERROR, payload: err.message });
		});
}

export const getInstallsFiltersData = (url, params) => (dispatch) => {
	fetch(`${url}?${new URLSearchParams(params).toString()}`)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: INSTALLS_FILTERS_DATA, payload: data._data.filters });
				dispatch({ type: INSTALLS_FILTERS_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: INSTALLS_FILTERS_ERROR, payload: err.message });
		});
}